// extracted by mini-css-extract-plugin
module.exports = {"form":"ResetForm_form__31ksi","error-label":"ResetForm_error-label__2CA3j"};